import { render, staticRenderFns } from "./DashboardKpis.vue?vue&type=template&id=b81d85f6"
import script from "./DashboardKpis.vue?vue&type=script&lang=js"
export * from "./DashboardKpis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports